<script>
import Template from '{Template}/Web/Pages/Staking/Stakings.template'
import AppLayout from '@/Layouts/AppLayout'
import IconFilter from "@/Components/Table/IconFilter";

export default Template({
    components: {
        AppLayout,
        IconFilter
    },
    data() {
        return {
            sending: false,
            filter: {
                sortBy: null,
            },
        }
    },
    props: {
        stakings: Object,
        sort: String
    },
    methods: {
        setStaking(staking) {
            this.$inertia.visit(route('staking', staking.id));
        },
        setSort(sort) {
            this.$inertia.visit(route('stakings', {'sort': sort}));
        },
        redeem(id) {

            if(this.sending) return;

            if (confirm(this.$t("Are you sure you want to redeem your staked coins in advance? You will not receive earned rewards in this case.")) == true) {

                axios.post(route('staking.redeem'), { id: id}).then((response) => {
                    this.sending = false;
                    this.$toast.success('Your coins successfully have been redeemed');
                    this.$inertia.visit(route('stakings', {'sort': 'my'}));
                }).catch(error => {
                    this.sending = false;
                    _.each(error.response.data.errors, (field, key) => {
                        if(field[0] !== "") {
                            this.$toast.error(field[0]);
                        }
                    });
                });

            }
        }
    }
})
</script>
